import { render, staticRenderFns } from "./installation_commands.vue.js?vue&type=template&id=b65cfe0c!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./installation_commands.vue?vue&type=template&id=b65cfe0c"
import script from "./installation_commands.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./installation_commands.vue?vue&type=script&lang=js"
export * from "./installation_commands.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./installation_commands.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports